import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { passwordUpdate } from "../config";

// Add password update async thunk
export const updateUserPassword = createAsyncThunk(
  "onboarding/updateUserPassword",
  async (_, { getState, rejectWithValue }) => {
    const { account, password } = getState();
    try {
      if (!account.currentUser) {
        throw new Error('User not authenticated');
      } 
      await passwordUpdate(account.currentUser, password.password);
      
      return { success: true };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const passwordSlice = createSlice({
  name: "password",
  initialState: {
    password: '',
    confirmPassword: '',
    completed: false,
    validated: false,
    processing: false,
    error: null,
  },
  reducers: {
    setCompleted: (state, action) => {
      state.completed = action.payload;
    },
    setPassword: (state, action) => {
      state.password = action.payload;
      const hasPassword = action.payload.length >= 8;
      const passwordsMatch = action.payload === state.confirmPassword && action.payload.length > 0;
      state.validated = hasPassword && passwordsMatch;
    },
    setConfirmPassword: (state, action) => {
        state.confirmPassword = action.payload;
        const hasPassword = state.password.length >= 8;
        const passwordsMatch = state.password === action.payload && action.payload.length > 0;
        state.validated = hasPassword && passwordsMatch;
    }
  },
  extraReducers: {
    [updateUserPassword.pending]: (state) => {
      state.processing = true;
      state.error = null;
    },
    [updateUserPassword.fulfilled]: (state) => {
      state.processing = false;
      state.completed = true;
      state.validated = true;
    },
    [updateUserPassword.rejected]: (state, action) => {
      state.processing = false;
      state.error = action.payload;
    }
  },
});

export const {
  setCompleted,
  setPassword,
  setConfirmPassword
  
} = passwordSlice.actions;

export default passwordSlice.reducer;